// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__zbC7F","buttons":"PendingPaymentAlert_buttons__3z3C3"};